export default __webpack_public_path__ + "static/media/basic-push-pin-12.104ba8ac.png";